import useAuthenticateMutation from 'services/authenticateMutation/useAuthenticateMutation'
import type { AuthenticateMutationResult } from 'services/authenticateMutation/authenticateMutation.types'
import useAuthorizeMutation from 'services/authorizeMutation/useAuthorizeMutation'
import type { AuthorizeMutationResult } from 'services/authorizeMutation/authorizeMutation.types'
import useCompleteMutation from 'services/completeMutation/useCompleteMutation'
import type { CompleteMutationResult } from 'services/completeMutation/completeMutation.types'
import type { AuthFlowType } from 'typings/Auth'

interface AuthSignIn {
  /** useMutation returned object values for /authenticate service */
  isLoadingAuthenticate: AuthenticateMutationResult['isLoading']
  isErrorAuthenticate: AuthenticateMutationResult['isError']
  authenticateErrorData: AuthenticateMutationResult['error']
  authenticateSignin: AuthenticateMutationResult['mutateAsync']
  /** useMutation returned object values for /complete service */
  isLoadingComplete: CompleteMutationResult['isLoading']
  completeSignin: CompleteMutationResult['mutateAsync']
  /** useMutation returned object values for /authorize service */
  isLoadingAuthorize: AuthorizeMutationResult['isLoading']
  authorizeUserAndRedirect: AuthorizeMutationResult['mutate']
}

const useAuthSignIn = (authType: AuthFlowType): AuthSignIn => {
  const {
    isLoading: isLoadingAuthenticate,
    isError: isErrorAuthenticate,
    error: authenticateErrorData,
    mutateAsync: authenticateSignin
  } = useAuthenticateMutation({ authType })

  const { isLoading: isLoadingComplete, mutateAsync: completeSignin } =
    useCompleteMutation({ authType })

  const { isLoading: isLoadingAuthorize, mutate: authorizeUserAndRedirect } =
    useAuthorizeMutation({ authType })

  return {
    isLoadingAuthenticate,
    isErrorAuthenticate,
    authenticateErrorData,
    authenticateSignin,
    isLoadingComplete,
    completeSignin,
    isLoadingAuthorize,
    authorizeUserAndRedirect
  }
}

export default useAuthSignIn
